import * as tslib_1 from "tslib";
import { ReplaySubject, merge } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
var BaseDataSource = /** @class */ (function () {
    function BaseDataSource() {
        this.unsubscribe$ = new ReplaySubject(1);
        // Request payload
        this._payload = {};
        // Was data tried to load once or not
        this.isFirstTimeLoaded = false;
        // Array with all data displayed on the current page
        this.currentPage = [];
    }
    Object.defineProperty(BaseDataSource.prototype, "payload", {
        get: function () {
            return this._payload;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseDataSource.prototype, "dataObservable$", {
        get: function () {
            return this._dataObservable$;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Default data source method
     * @method connect
     */
    BaseDataSource.prototype.connect = function (collectionViewer) {
        var _this = this;
        var tableEvents$ = [];
        if (this.sort) {
            tableEvents$.push(this.sort.sortChange);
        }
        if (this.paginator) {
            tableEvents$.push(this.paginator.page);
        }
        merge.apply(void 0, tableEvents$).pipe(takeUntil(this.unsubscribe$))
            .subscribe(function () {
            _this.updateTablePayload();
            _this.loadData();
        });
        // Takes data and sets to internal variable
        // Set flag for init, do not forget to skip first store value
        return this.dataObservable$
            .pipe(tap(function (data) {
            _this.currentPage = data;
            _this.isFirstTimeLoaded = true;
        }));
    };
    /**
     * Default data source method
     * @method disconnect
     */
    BaseDataSource.prototype.disconnect = function (collectionViewer) {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    };
    /**
     * Integrates data source with all features like pagi, sort and etc.
     * @method initDataSource
     */
    BaseDataSource.prototype.initDataSource = function (settings) {
        var _this = this;
        if (settings.sort) {
            this.sort = settings.sort;
        }
        if (settings.paginator) {
            this.paginator = settings.paginator;
            Object.entries(settings.paginatorConfigs).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                _this.paginator[key] = value;
            });
        }
        this.updateTablePayload();
    };
    /**
     * Sets pagination or sorting data to payload
     * @method updateTablePayload
     */
    BaseDataSource.prototype.updateTablePayload = function () {
        if (this.sort) {
            switch (this.sort.direction) {
                case 'asc':
                    this.payload.sort = "" + this.sort.active;
                    break;
                case 'desc':
                    this.payload.sort = "-" + this.sort.active;
                    break;
                default:
                    this.payload.sort = undefined;
                    break;
            }
        }
        if (this.paginator) {
            if (!this.paginator.pageSize) {
                this.paginator.pageSize = this.paginator.pageSizeOptions[0];
            }
            this.payload.limit = this.paginator.pageSize;
            this.payload.offset = this.paginator.pageSize * this.paginator.pageIndex;
        }
    };
    /**
     * Sets payload and update UI to new payload
     * @method setPayload
     */
    BaseDataSource.prototype.setPayload = function (payload) {
        // Cannot update sorting UI, material doesn't support
        // if (payload.sort !== undefined) {
        //   const sortingArray: Array<string> = payload.sort.split('-');
        //   const sortingObject: any = {
        //     id: sortingArray.length === 1 ? sortingArray[0] : sortingArray[1],
        //     start: sortingArray.length === 1 ? 'asc' : 'desc'
        //   }
        // }
        if (this.paginator && (payload.limit !== undefined || payload.offset !== undefined)) {
            var newLimit = payload.limit ? payload.limit : this.paginator.pageSize;
            var newOffset = payload.offset ? payload.offset : this.paginator.pageSize * this.paginator.pageIndex;
            this.paginator.pageSize = newLimit;
            this.paginator.pageIndex = newOffset / newLimit;
            this.paginator.length = this.paginator.length;
        }
        this._payload = tslib_1.__assign({}, this.payload, payload);
    };
    return BaseDataSource;
}());
export { BaseDataSource };
